import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=543acd76&scoped=true"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/leftMenu.scss?vue&type=style&index=0&id=543acd76&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543acd76",
  null
  
)

export default component.exports